"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CookieParameter;
var _react = _interopRequireWildcard(require("react"));
var _cookies_config = _interopRequireDefault(require("Components/Cookies/cookies_config"));
var _CookiesStore = _interopRequireDefault(require("Components/Stores/CookiesStore"));
var _utilities = require("Shared/utilities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function CookieParameter({
  code,
  ...props
}) {
  const config = _cookies_config.default[code] || {};
  const {
    onAcceptation,
    onDenied,
    init
  } = config;
  const load = typeof config.load === 'function' ? config.load : undefined;
  const active = _CookiesStore.default.useState(function (store) {
    return (0, _utilities.isTrue)(store['enabled_' + code]);
  });
  const param_id = _CookiesStore.default.useState(function (store) {
    return store['param_' + code + '_id'];
  });
  (0, _react.useEffect)(function () {
    if (typeof init === 'function') init();
  }, [init]);
  (0, _react.useEffect)(function () {
    if (typeof onDenied === 'function' && active === false) {
      onDenied();
      window.localStorage.setItem('custom_consent_' + code, 'false');
    } else if (typeof init === 'function' && active === true) {
      onAcceptation();
      window.localStorage.setItem('custom_consent_' + code, 'true');
    }
  }, [code, onAcceptation, onDenied, active, init]);
  (0, _react.useEffect)(function () {
    if (!load || !param_id) return;
    load(param_id);
  }, [param_id, load]);
  return null;
}
